{
  "Programcı": "Programcı",
  "menu": {
    "Admin": "Admin",
    "Href": "Href",
    "Menü Düzenle": "Menü Düzenle",
    "Menü Yönetimi": "Menü Yönetimi",
    "Programcı": "Programcı",
    "Silmek istediğinize emin misiniz? Alt menüler de silinecektir": "Silmek istediğinize emin misiniz? Alt menüler de silinecektir.",
    "Sıralamayı Kaydet": "Sıralamayı Kaydet",
    "Virgül ile ayırın": "Virgül ile ayırın",
    "Yeni Menü Ekle": "Yeni Menü Ekle",
    "Yetki Ayarları": "Yetki Ayarları",
    "Yetki Kodları (Örn: 101002, 102002)": "Yetki Kodları (Örn: 101002, 102002)",
    "JSON format hatası: ": "JSON format hatası: ",
    "Yeni Menü": "Yeni Menü",
    "edit": "edit",
    "delete": "delete"
  }
}
